module.exports = __webpack_public_path__ + "img/cover-box-2-3-1.8c4e51fa.png";